import * as actions from './actions';
import API from 'api';
import {URL_GET_ROUTE} from 'api/config';

export const getRoute = (hash, shouldBeLoaderVisible, callback, navigate) => {
  return async dispatch => {
    if (shouldBeLoaderVisible) {
      dispatch(actions.setRouteLoading(true));
    }
    try {
      const res = await API.get(URL_GET_ROUTE, {
        params: {
          hash,
        },
      });
      if (res.success) {
        dispatch(actions.setRoute(res.data));
        dispatch(actions.setCanRefresh(res.data.refresh));
        if (res.data && res.data.ended) {
          if (navigate) {
            navigate('/info', {
              state: {
                success: false,
                title: 'Link udostępniania lokalizacji wygasł!',
                desc: 'Udostępniany przejazd zakończył się lub dane zawarte w linku są niepoprawne.'
              },
            });
          }
        }
      } else {
        if (callback) {
          callback();
        }
      }
      if (shouldBeLoaderVisible) {
        dispatch(actions.setRouteLoading(false));
      }
    } catch(err) {
      if (callback) {
        callback();
      }
      console.log(err);
    }
  };
};
